import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-android"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 18C1 11.9249 5.92487 7 12 7C18.0751 7 23 11.9249 23 18V19H1V18Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6.11656 8.70397L4 5M6.11656 8.70397C3.04126 10.6544 1 14.0888 1 18V19H23V18C23 14.0888 20.9587 10.6544 17.8834 8.70397M6.11656 8.70397C7.81804 7.62485 9.83605 7 12 7C14.164 7 16.182 7.62485 17.8834 8.70397M17.8834 8.70397L20 5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M7 14H7.00391V14.0039H7V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M17 14H17.0039V14.0039H17V14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const LogoAndroid = Vue.extend<IconProps>({
  name: 'LogoAndroidIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-android',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoAndroid;
